import { render } from "./PublishCalendar.vue?vue&type=template&id=18364bbd&scoped=true"
import script from "./PublishCalendar.vue?vue&type=script&lang=js"
export * from "./PublishCalendar.vue?vue&type=script&lang=js"

import "./PublishCalendar.vue?vue&type=style&index=0&id=18364bbd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18364bbd"]])

export default __exports__